import { Component, input } from '@angular/core';
import { format } from 'date-fns';
import { TranslatePipe } from '@ngx-translate/core';

export interface IEvent {
  date: string;
  title: { locale: string; value?: any };
  description: { locale: string; value?: any };
  suggestion?: string;
}

@Component({
  selector: 'app-timeline-v2',
  imports: [TranslatePipe],
  templateUrl: './timeline-v2.component.html',
  styleUrl: './timeline-v2.component.scss'
})
export class TimelineV2Component {
  events = input<IEvent[]>();

  // 01 Sep 2024
  getFormattedDate(date: string): string {
    if (!date) {
      return '-';
    }
    return format(new Date(date), 'dd MMM yyyy');
  }
}
